import * as R from 'unitx/ramda';
import { mapping as NativeDefaultMapping } from '@eva-design/eva';
export const Mapping = R.mergeDeepRight(NativeDefaultMapping, {
  components: {
    Avatar: {
      meta: {
        variantGroups: {
          size: {
            small: {
              default: true
            }
          }
        }
      }
    },
    Button: {
      meta: {
        appearances: {
          outline: {
            default: true
          }
        },
        variantGroups: {
          size: {
            small: {
              default: true
            }
          }
        }
      }
    },
    ButtonGroup: {
      meta: {
        appearances: {
          outline: {
            default: true
          }
        },
        variantGroups: {
          size: {
            small: {
              default: true
            }
          }
        }
      }
    },
    Datepicker: {
      meta: {
        variantGroups: {
          size: {
            small: {
              default: true
            }
          }
        }
      }
    },
    Input: {
      meta: {
        variantGroups: {
          size: {
            small: {
              default: true
            }
          }
        }
      }
    },
    Select: {
      meta: {
        variantGroups: {
          size: {
            small: {
              default: true
            }
          }
        }
      }
    },
    Spinner: {
      meta: {
        variantGroups: {
          size: {
            small: {
              default: true
            }
          }
        }
      }
    }
  }
});